<template>
  <div class="signup">
    <div class="container mt-3 px-0">
      <h2 class="title text-center pt-3">{{$t("message.select_language")}}</h2>
      <div class="row mt-4 mx-2 px-4">
        <div class="col-12 col-lg-6 px-2 mx-auto">
          <v-select class="simple-v-select" label="text" :options="LANGUAGE_ARR" v-model="select"></v-select>
          <p v-if="langValid" class="error">{{$t("message.error_lang")}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      select: null,
      langValid: false,
      idToken: localStorage.idToken,
      flag: {
        vietnamese: require('../../../assets/flag/vietnamese.png')
      }
    }
  },
  methods: {
    setUrl(url){
      return {
          image_src: require(url)
        }
    },
    async regist_lang(){
      if(this.select != ""){
        this.langValid = false
        var regist = {user:{sub: this.user.sub, language: this.select}}
        var is_result = false

        this.$i18n.locale = this.LANGUAGE_LIST[this.select]
        this.$store.commit('setLanguage', this.LANGUAGE_LIST[this.select])

        await axios
          .patch(process.env.VUE_APP_API + "/users/" + this.user.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            is_result = true
            this.$store.commit('user/setUser', response.data)
          }).catch(error => {
            console.log('this is error', error)
          })
        return is_result
      } else{
        this.langValid = true
        return false
      }
    }
  },
  watch:{
    select(){
      if(this.select != ""){
        this.langValid = false
        var regist = {user:{sub: this.user.sub, language: this.select}}

        axios
          .patch(process.env.VUE_APP_API + "/users/" + this.user.id, regist, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.$store.commit('user/setUser', response.data)
            this.$store.commit('setLanguage', this.LANGUAGE_LIST[this.select])
            this.$emit('next', {mode: 'occupation'});
          }).catch(error => {
            console.log('this is error', error)
          })

      } else{
        this.langValid = true
      }
    },
  },
  computed: {
    ...mapState({
        user: state => state.user.user
    })
  },
}
</script>

<style scoped lang="scss">

  .error {
      border-color: red;
      background: mistyrose;
  }
  .btn-white{
    color: rgba(1, 1, 20, 0.87);
    border: 1px solid rgba(1, 1, 20, 0.12);
    background-color: white ;

    &:hover{
      color: #FFFFFF;
      border: 0px solid rgba(1, 1, 20, 0.12);
      background-color: #000054 !important;
    }
  }
  .active{
    color: #FFFFFF;
    border: 0px solid rgba(1, 1, 20, 0.12) !important;
    background-color: #000054 !important;
  }

  .topSelect {
    color: silver;
    max-width: 100%;
    z-index: unset !important;
    border-bottom: solid 2px silver;
    border-radius: 0;
    padding-left: 1rem;
  }
</style>
